<template>
  <div class="AddChapter">
    <h2>Добавить главу</h2>
    <ElemInput
      valueName="title"
      @changeValue="changeValue"
      :valueProp="title"
      label="Заголовок"
    />

    <ElemTextarea
      valueName="description"
      @changeValue="changeValue"
      :valueProp="description"
      label="Краткое описание"
    />

    <ElemInput
      valueName="author"
      @changeValue="changeValue"
      :valueProp="author"
      label="Автор"
    />

    <ElemSelect
      valueName="status"
      @changeValue="changeValue"
      :valueProp="status"
      label="Статус"
      :options="statusOptions"
    />

    <ElemInput
      valueName="order"
      @changeValue="changeValue"
      :valueProp="order"
      label="Порядок"
    />
    
    <span class="name">Текст</span>

    <TextEditor v-model="text" />

    <div class="form-actions">
      <button type="button" v-on:click="updateChapter">Обновить</button>
    </div>
  </div>
</template>

<script>
import TextEditor from "@/components/TextEditor.vue";
import ElemInput from "@/components/elements/elemInput";
import ElemSelect from "@/components/elements/elemSelect";
import chapters from "@/composables/views/stories-chapters.ts";
import ElemTextarea from "@/components/elements/elemTextarea";

export default {
  props: {
    storiesId: Number,
    id: Number,
  },
  setup(props, context) {
    const { emit } = context;

    const {
      title,
      description,
      author,
      status,
      statusOptions,
      order,
      text,
      updateChapter,
      getChapter,
    } = chapters(props.id, props.storiesId, emit);
    return {
      title,
      description,
      author,
      status,
      statusOptions,
      order,
      text,
      updateChapter,
      getChapter,
    };
  },
  data: () => ({}),
  components: {
    TextEditor,
    ElemInput,
    ElemTextarea,
    ElemSelect,
  },
  methods: {
    changeValue(valueName, value) {
      this[valueName] = value;
    },
  },
  created() {
    this.getChapter();
  },
};
</script>